import * as React from 'react';
import { IWebGroupFilterGroup } from '../webgroup-filters';

export const WebGroupFilter: React.FC<IWebGroupFilterGroup> = ({ name, filters, filterChange }) => {
    return (
        <div className='webgroup-filter'>
            {filters.map((f: any, index: number) => {
                return (
                    <div key={index} className='filter-item'>
                        <input
                            type='checkbox'
                            className='filter-checkbox'
                            value={f.LeftValueBoundString}
                            onChange={e => filterChange(e, f, name)}
                        />
                        <span data-sort={f.RowNumber}>{f.LeftValueBoundString}</span>
                    </div>
                );
            })}
        </div>
    );
};
